/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector } from '@angular/core';
/* eslint-disable */
import { FormEditCreateUpdateProcessOrderStockOuttakeCheckFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/process-order-stock-outtake-check/create-update/form-edit-create-update-process-order-stock-outtake-check-field-dialog.component';
/* eslint-enable */

/* eslint-enable */

export class FormEditProcessOrderStockOuttakeCheckFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateProcessOrderStockOuttakeCheckFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateProcessOrderStockOuttakeCheckFieldDialogComponent)
      .create(this.injector);
  }

}
